// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2erPT","signatureButtonsRight":"ModalSign_signatureButtonsRight__1DVCg"};